var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSteep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 599 416",
    height: "100%",
    width: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_544)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M448.44 182.82L373.74 264.36L299.04 221.23L373.74 139.69L448.44 182.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M373.74 264.36L448.44 182.82L523.14 225.95L448.44 307.49L373.74 264.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M373.74 264.36L448.44 307.49L299.04 341.9L373.74 264.36V264.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M523.14 225.95L448.44 182.82L523.14 139.69L597.84 182.82L523.14 225.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M448.44 182.82L373.74 139.69L448.44 96.5601L523.14 139.69L448.44 182.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M448.44 96.5701L373.74 139.7L299.04 86.6901L373.74 43.5601L448.44 96.5701Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M448.44 307.49L373.74 371.73L299.04 341.9L448.44 307.49V307.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M373.74 264.36L299.04 341.9V221.23L373.74 264.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M299.04 341.9L373.74 371.73L299.04 414.86V341.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M149.65 134.98L224.34 43.5601L299.04 86.6901L224.34 178.11L149.64 134.98H149.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M149.65 134.98L224.35 178.11L149.65 242.35L74.95 199.22L149.65 134.98V134.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M224.34 178.11L299.04 86.6899V221.23L224.34 178.1V178.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M299.04 86.6899L224.34 43.5599L299.04 0.429932L373.74 43.5599L299.04 86.6899Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M224.34 178.11L299.04 221.24L224.34 285.48L149.64 242.35L224.34 178.11V178.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M373.74 139.7L299.04 221.24V86.6899L373.74 139.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M224.34 285.47L299.04 221.23V341.9L224.34 285.47V285.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M149.65 242.35L224.35 285.48L149.65 328.61L74.95 285.48L149.65 242.35V242.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M74.95 199.22L149.65 242.35L74.95 285.48L0.25 242.35L74.95 199.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M299.04 414.86L224.34 371.73L299.04 341.9V414.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M299.04 341.9L224.34 371.73L149.64 328.6L299.04 341.9V341.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5FC",
    d: "M149.65 328.6L224.35 285.47L299.05 341.9L149.65 328.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M448.44 182.82L373.74 264.36M448.44 307.49L373.74 264.36"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M523.14 225.95L448.44 307.49"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M523.14 225.95L448.44 182.82M448.44 96.5701L373.74 139.7M448.44 182.83L373.74 139.7M523.14 139.7L448.44 182.83"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M523.14 139.7L448.44 96.5701M448.44 307.49L373.74 371.73"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M373.74 264.36L299.04 341.9M373.74 371.73L299.04 341.9"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M597.83 182.82L523.13 225.95M597.83 182.82L523.13 139.69M224.34 43.5601L149.64 134.98"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M224.34 178.11L149.64 134.98M299.04 86.6901L224.34 178.11M299.04 86.6901L224.34 43.5601M299.04 221.23L224.34 178.1M373.74 139.69L299.04 221.23M373.74 139.69L299.04 86.6801M299.04 221.23L224.34 285.47M224.34 178.1L149.64 242.34M224.34 285.47L149.64 242.34"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M149.65 134.98L74.95 199.22"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M149.65 242.35L74.95 199.22"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M299.04 0.429932L224.34 43.5599"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M373.74 43.5601L299.04 86.6901"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M373.74 43.5599L299.04 0.429932M373.74 371.73L299.04 414.86"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M299.04 341.9L224.34 371.73"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M299.04 414.86L224.34 371.73"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M149.65 242.35L74.95 285.47"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M74.95 199.22L0.25 242.35M74.95 285.48L0.25 242.35"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M224.34 285.47L149.65 328.6"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M149.65 328.6L74.95 285.47M224.35 371.72L149.65 328.59"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M299.04 341.9L224.34 285.47"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#2A2CB1",
    d: "M448.44 96.5701L373.74 43.5601"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    stroke: "#2A2CB1",
    d: "M373.74 264.36L299.04 221.23"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_544"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: 415.29,
    width: 598.08
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteep);
export default __webpack_public_path__ + "static/media/steep.38947bd8cf8cb9f3343b76053b37dc14.svg";
export { ForwardRef as ReactComponent };